import { Component } from '@angular/core';
import { BaseButtonComponent } from '../base-button';

@Component({
  selector: 'app-cancel-hold-button',
  templateUrl: './cancel-hold-button.component.html',
  styleUrls: ['./cancel-hold-button.component.scss', '../base-button.scss'],
})
export class CancelHoldButtonComponent extends BaseButtonComponent {

  cancelHold() {
    this.doAction(
      () => {
        const hold = this.holdsFacade.getHoldByRecordId(this.record.id, this.issueDate, this.rhId);

        this.holdsFacade.deleteHold(hold.id).subscribe(
          () => {
            this.toastService.showToast('messages.holds.cancel');
          },
          () => {},
          () => {
            this.waiting = false;
          }
        );
      },
      null,
      true
    );
  }
}
